import { Component, ViewChild } from '@angular/core';
import { IonInfiniteScroll, NavController, } from '@ionic/angular';
import { RanglistListModel, RanglistSearchModel, ResultProvider } from '../../../providers/result/result';
import { Router } from '@angular/router';

/**
 * Generated class for the ResoultRanglistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-ranglist',
  templateUrl: 'result-ranglist.html',
  styleUrls:['./result-ranglist.scss']
})
export class ResultRanglistPage {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  search: RanglistSearchModel;
  list: RanglistListModel[] = [];

  constructor(public navCtrl: NavController, public router:Router, public resultService: ResultProvider) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    console.log(state);
    this.search = state['data'].search;
    this.list = state['data'].list;
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter ResoultRanglistPage');
  }

  loadNextPage(event: IonInfiniteScroll) {
    this.resultService.getRangList(this.search).then((data: RanglistListModel[]) => {
      this.list = data;
      event.complete();
    });
  }

}
